import styled from "styled-components";
import CloseImg from "@/assets/svg/close.svg";
import CircleImg from "@/assets/svg/circle.svg";
import { ReactSVG } from "react-svg";
import { useState } from "react";



export default function Stake({ handleClose }) {
  
  return (
    <Modal>      
      <div className='close' onClick={handleClose}><ReactSVG src={CloseImg}/></div>
      <div className="content">        
        <svg className="spinner" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M25.6618 6.96577C26.3896 6.41735 27.433 6.55892 27.8982 7.34249C29.5386 10.1054 30.256 13.3368 29.9185 16.5614C29.5235 20.3357 27.7126 23.8199 24.8508 26.3121C21.9889 28.8042 18.2888 30.119 14.4961 29.9915C10.7034 29.8641 7.09998 28.3038 4.41193 25.6251C1.72388 22.9464 0.151028 19.3484 0.0103153 15.5562C-0.130397 11.7639 1.17149 8.05931 3.65363 5.18879C6.13578 2.31826 9.61368 0.495226 13.3865 0.08703C16.6099 -0.261717 19.8438 0.444424 22.6124 2.07514C23.3976 2.53762 23.5428 3.58055 22.997 4.31024C22.4511 5.03992 21.4213 5.17718 20.6222 4.73928C18.5344 3.59534 16.1342 3.10901 13.7415 3.36788C10.7987 3.68628 8.08591 5.10824 6.14983 7.34725C4.21376 9.58626 3.19829 12.4759 3.30805 15.4338C3.4178 18.3918 4.64462 21.1982 6.7413 23.2876C8.83798 25.3769 11.6487 26.594 14.607 26.6934C17.5653 26.7928 20.4514 25.7673 22.6836 23.8234C24.9158 21.8795 26.3283 19.1618 26.6364 16.2179C26.887 13.8243 26.3923 11.4258 25.241 9.34207C24.8003 8.54444 24.934 7.51419 25.6618 6.96577Z" fill="white" fillOpacity="0.9"/>
        </svg>
        <div className="noop"></div>
        <div className="approve-text">
          Approve this transaction in your wallet
        </div>
      </div>
    </Modal>
  );
}

const Modal = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  .close {
    position: absolute;
    right: 25px;
    top: 27px;
    cursor: pointer;
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @keyframes rotate{
   from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
  .noop{
    height:20px;
  }
  .spinner{
    margin-top: 56px;
    width: 22px;
    height: 22px;    
    animation: 2s rotate linear infinite;
  }
  .approve-text{
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;    
    color: #32DE86;
    padding-top:25px;
  }

`;
